import { Box, Typography } from "@mui/material";

const CountCard = ({ data }: any) => {
  return (
    <Box
      sx={{
        boxShadow: "0px 1px 3px 0px #0000001A",
        p: 2,
        minHeight: "134px",
        bgcolor: "#FFFFFF",
        borderRadius: "12px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Typography color="text.primary" fontWeight={"700"} fontSize={"36px"}>
          {(data?.value).toLocaleString()}
        </Typography>
      </Box>
      <Typography
        sx={{ color: "text.primary", fontSize: "16px", fontWeight: "700" }}
      >
        {data?.title}
      </Typography>
    </Box>
  );
};

export default CountCard;
